<template>
  <DownloadBox :downloadOptions="downloadOptions" :labels="labels"/>
</template>

<script>
import DownloadBox from "../../components/DownloadBox/DownloadBox.vue";

export default {
  name: "app",
  components: {
    DownloadBox
  },
  data() {
    return {
      downloadOptions: JSON.parse(this.$options._parentVnode.data.props.downloadOptions),
      labels: JSON.parse(this.$options._parentVnode.data.props.labels)
    };
  }
};
</script>
